// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import unescape from 'lodash/unescape';
import isArray from 'lodash/isArray';
import forEach from 'lodash/forEach';

import { fetchDlcLinks } from '../../../../actions';
import { API_URL } from '../../../../constants';
import i18n from '../../../../i18n/i18n.js';

type Props = {
    content: string,
};

class Dlc extends Component<Props> {
    constructor(props: Props) {
        super(props);
        this.state = { links: [] };
    }

    componentDidMount() {
        const asset = this.props.asset;

        this.props.fetchDlcLinks(asset.id, dlcLinks => {
            if (dlcLinks.length !== 0) this.setState({ links: dlcLinks });
            else throw new Error('There is no downloadable content.');
        });
    }

    downloadContent = url => {
        window.location = url;

        const asset = this.props.asset;
        this.props.fetchDlcLinks(asset.id, dlcLinks => {
            if (dlcLinks.length !== 0) this.setState({ links: dlcLinks });
            else throw new Error('There is no downloadable content.');
        });
    };

    renderLink = (link: Object, i: number) => {
        const url = API_URL + '/dlc/' + link.token;
        const thumb =
            link.thumbnail !== undefined ? (
                <img
                    width="150px"
                    height="150px"
                    className="inplayer-dlc-thumb"
                    src={link.thumbnail}
                    alt="thumb"
                />
            ) : (
                ''
            );
        const size =
            link.filesize !== undefined
                ? '(' + Math.round(link.filesize / 1024) + ' kb)'
                : '';
        const lng = this.props.language;

        return (
            <div className="inplayer-dlc-file" key={i}>
                {thumb}
                <div className="inplayer-dlc-title">
                    {link.title + ' ' + size}
                </div>
                <a
                    className="inplayer-download-btn"
                    onClick={e => this.downloadContent(url)}
                >
                    <img
                        title={i18n.t('dlc_download', { lng })}
                        src="https://assets.inplayer.com/images/download-btn.png"
                    />
                </a>
                <div className="inplayer-dlc-description">
                    {link.file_description}
                </div>
            </div>
        );
    };

    render() {
        return (
            <div ref={div => (this.dlc = div)} className="inplayer-dlc-wrapper">
                {this.state.links.map(this.renderLink)}
            </div>
        );
    }
}

const mapStateToProps = (state: Object) => {
    return {
        language: state.auth.language,
    };
};

export default connect(
    mapStateToProps,
    {
        fetchDlcLinks,
    }
)(Dlc);



// WEBPACK FOOTER //
// ./src/containers/Asset/ContentInjectors/Dlc/index.js